import React, { useEffect, useRef, useState } from "react";
import {
  Card,
  Row,
  Container,
  CardHeader,
  Col,
  CardBody,
  CardTitle,
  NavItem,
  TabContent,
  NavLink,
  Nav,
  CardText,
  Button,
  Table,
  FormGroup,
  FormText,
  Form,
  Input,
  Label,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  TabPane,
  ListGroup,
  ListGroupItem,
  CardFooter,
  UncontrolledTooltip,
  Badge,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import Swal from "sweetalert2";
import EnquiryModal from "models/enquiries.modal";
import TablePagination from "views/components/TablePagination";
import PayrollModel from "models/payroll.modal";
import { helper } from "lib/helper";
import moment from "moment";
import Tutorsmodel from "models/tutors.modal";
import ClassModal from "models/class.modal";
import { toast } from "lib/helper";
import Loader from "components/loader/Loader";
import Salarytutors from "models/salary.modal"

const Payments = ({tutorsalary,tutorpayroll}) => {
  const [isLoading, setIsLoading] = useState(true);
  const [dataList, setDataList] = useState([]);
  const [modal, setModal] = useState(false);
  const [modal1, setModal1] = useState(false);
const parms = useParams();
  const toggleModal = () => {
    setModal(!modal);
  };
  const toggleModal1 = () => {
    setModal1(!modal1);
  };
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const parameters = {};
  for (let [key, value] of searchParams) {
    parameters[key] = value;
  }
  const initialPage = searchParams.get("page") || 1;
  const [currentPage, setCurrentPage] = useState(
    parseInt(initialPage, 10) || 1
  );
  const [perPage, setPerPage] = useState(10);
  const tableRef = useRef(null);
  const downloadPDF = () => {
    const input = tableRef.current;

    if (!input) {
      console.error("Table element not found.");
      return;
    }

    html2canvas(input)
      .then((canvas) => {
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF("p", "mm", "a4");
        const width = pdf.internal.pageSize.getWidth();
        const height = (canvas.height * width) / canvas.width;
        pdf.addImage(imgData, "PNG", 0, 0, width, height);
        pdf.save("tutors_payroll_list.pdf");
      })
      .catch((error) => {
        console.error("Error generating PDF:", error);
      });
  };
  const [newEquries, setnewEnquries] = useState();
  const [qualifiedEquries, setQualifiedEnquries] = useState();
  const [Pendingss, setPendingss] = useState();
  const [Disqualify, setDisqualify] = useState();

  const getalldataNumber = async () => {
    EnquiryModal.Addnewequriey()
      .then((responce) => {
        setnewEnquries(responce?.data);
      })
      .catch((error) => {
        console.log("error", error);
      });
    EnquiryModal.QualifiedEnquiry()

      .then((responce) => {
        setQualifiedEnquries(responce?.data);
      })
      .catch((error) => {
        console.log("error", error);
      });
    EnquiryModal.Pendingss()

      .then((responce) => {
        setPendingss(responce?.data);
      })
      .catch((error) => {
        console.log("error", error);
      });
    EnquiryModal.Disqualify()

      .then((responce) => {
        setDisqualify(responce?.data);
      })
      .catch((error) => {
        console.log("error", error);
      });
  };
  const getListData = async () => {
    setIsLoading(true);
    await PayrollModel.list(parameters)
      .then((result) => {
        setIsLoading(false);
        if (result) {
          //console.log("tutor list ------>",result);
          setDataList(result?.data);
          setCurrentPage(result?.meta?.current_page);
          setPerPage(result?.meta?.per_page);
        }
      })
      .catch((error) => {
        helper.sweetalert.toast(error.response?.data?.message, "warning");
        setIsLoading(false);
      });
  };
  const [tutor, setTutor] = useState();
  const tutorlist = async () => {
    Tutorsmodel.GetAllTutor()
      .then((responce) => {
        setTutor(responce?.data?.data);
      })
      .catch((error) => {
        console.log("error", error);
      });
  };
  const [classlist, setClasslist] = useState();
  const getalllist = async () => {
    ClassModal.listClassNew()
      .then((responce) => {
        setClasslist(responce?.data);
      })
      .catch((error) => {
        console.log("error", error);
      });
  };
  console.log("class", classlist);
  useEffect(() => {
    getalllist();
    getListData();
    tutorlist();
    setCurrentPage(parseInt(searchParams.get("page"), 10) || 1);
    getalldataNumber();
  }, [location]);

  const AddPayroll = async (event) => {
    event.preventDefault();
    const form = new FormData(event.target);

    const Cycledate = form.get("cycle_completion_date");
    const duedate = form.get("payment_due_date");

    const [yyyy, mm, dd] = Cycledate.split("-");
    const [YYYY, MM, DD] = duedate.split("-");

    const correctformate = `${dd}/${mm}/${yyyy}`;
    const correctformate1 = `${dd}/${mm}/${yyyy}`;

    form.set("cycle_completion_date", correctformate);
    form.set("payment_due_date", correctformate1);

    Salarytutors.Addsalary(form)
      .then((responce) => {
        toggleModal();
        tutorpayroll();
        toast("Payroll added sucessfully", "success");
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  const Delpatroll = async (id) => {
    PayrollModel.delete(id)
      .then((responce) => {
        toast("Payroll sucessfully deleted", "success");
       
        tutorpayroll();
      })
      .catch((error) => {
        console.log("error", error);
      });
  };
  const [searchTerm, setSearchTerm] = useState("");

  const filteredDataList = dataList?.filter((tutorItem) => {
    const fullName =
      `${tutorItem?.tutorInfo?.first_name} ${tutorItem?.tutorInfo?.last_name}`.toLowerCase();
    const email = tutorItem?.tutorInfo?.email.toLowerCase();
    const username = tutorItem?.tutorInfo?.username.toLowerCase();

    return (
      fullName.includes(searchTerm.toLowerCase()) ||
      email.includes(searchTerm.toLowerCase()) ||
      username.includes(searchTerm.toLowerCase()) // Now also searching by username
    );
  });
  const [datadetail, setDatadetail] = useState();
const [loading, setLoading] = useState(false);
  const getDetail = async (id) => {
    setLoading(true); // Set loading to true before fetching
    PayrollModel.detail(id)
      .then((response) => {
        setDatadetail(response?.data); // Set the fetched data
        setLoading(false); // Stop loading after the data is fetched
        toggleModal1(); // Open modal after data is fetched
      })
      .catch((error) => {
        console.log("error", error);
        setLoading(false); // Stop loading in case of error
      });
  };
  const [formattedCycleDate, setFormattedCycleDate] = useState("");
  const [formattedPaymentDate, setFormattedPaymentDate] = useState("");
  useEffect(() => {
    if (modal1 && datadetail) {
      // Format cycle_completion_date
      if (datadetail?.cycle_completion_date) {
        const [day, month, year] = datadetail.cycle_completion_date.split('/');
        const formattedCycle = `${year}-${month}-${day}`;
        setFormattedCycleDate(formattedCycle);
      }

      // Format payment_due_date
      if (datadetail?.payment_due_date) {
        const [day, month, year] = datadetail.payment_due_date.split('/');
        const formattedPayment = `${year}-${month}-${day}`;
        setFormattedPaymentDate(formattedPayment);
      }
    } else {
      // Reset dates when modal is closed
      setFormattedCycleDate("");
      setFormattedPaymentDate("");
    }
  }, [modal1, datadetail]);
 
  const EditPayroll =async(event)=>{
    event.preventDefault();
    const form = new FormData(event.target);

    const Cycledate = form.get("cycle_completion_date");
    const duedate = form.get("payment_due_date");

    const [yyyy, mm, dd] = Cycledate.split("-");
    const [YYYY, MM, DD] = duedate.split("-");

    const correctformate = `${dd}/${mm}/${yyyy}`;
    const correctformate1 = `${dd}/${mm}/${yyyy}`;

    form.set("cycle_completion_date", correctformate);
    form.set("payment_due_date", correctformate1);

    PayrollModel.edit(datadetail?.id,form)
      .then((responce) => {
        toggleModal1();
        getListData();
        toast("Payroll edit sucessfully", "success");
      })
      .catch((error) => {
        console.log("error", error);
      });
 }
 console.log("check tutor salary",tutorsalary)
  return (
    <>
      <div className="pt-7 md:pt-2 overflow-hidden px-4">
        {!isLoading && (
          <Row>
            <div className="col">
              <Card className="shadow">
                <CardHeader className="border-0 d-flex flex-column align-items-start">
                  {/* First Row: Title and Search */}
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <h3 className="mb-2 mb-md-0">All Payroll</h3>
                    <div className="d-flex flex-column flex-md-row justify-content-between">
                      <Input
                        className="mr-md-4 mb-2 mb-md-0 ml-md-4"
                        type="text"
                        placeholder="Search"
                        size="sm"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)} // Update search term
                      />
                      <Button
                        size="sm"
                        onClick={downloadPDF}
                        style={{
                          backgroundColor: "#080278",
                          color: "white",
                          border: "none",
                        }}
                      >
                        <i className="fa-solid fa-download"></i>
                      </Button>
                    </div>
                  </div>

                  {/* Second Row: +Add Button */}
                  <div
                    className="mt-4"
                    style={{ width: "100%", textAlign: "right" }}
                  >
                    <Button
                      size="sm"
                      onClick={toggleModal}
                      style={{
                        backgroundColor: "#080278",
                        color: "white",
                        fontSize: "13px",
                      }}
                    >
                      +Add
                    </Button>
                  </div>
                </CardHeader>
                <Row>
                  <Col md={12}>
                  

                    <div
                      ref={tableRef}
                      style={{ maxWidth: "100%", overflowX: "auto" }}
                    >
                      <Table
                        className="align-items-center table-flush"
                        responsive
                      >
                        <thead className="thead-light">
                          <tr>
                            <th scope="col">S.NO</th>
                            <th scope="col">Name</th>
                            <th scope="col">Email</th>
                            <th scope="col">Due Date</th>
                            <th scope="col">Completion Date</th>
                            <th scope="col">Bonus Amount</th>
                            <th scope="col">Deduction Amount</th>
                            <th scope="col">Total Amount</th>
                            <th scope="col">Status</th>
                            <th scope="col">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {tutorsalary?.map((tutorItem, tutorIndex) => (
                            <tr key={`tutor${tutorIndex}`}>
                              <td style={{ padding: "0.2rem" }}>
                                {(currentPage - 1) * perPage + tutorIndex + 1}
                              </td>
                              <td style={{ padding: "0.2rem" }}>
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                  }}
                                >
                                  <span>
                                    {tutorItem?.tutorInfo?.first_name}{" "}
                                    {tutorItem?.tutorInfo?.last_name}
                                  </span>
                                  <span> {tutorItem?.tutorInfo?.username}</span>
                                </div>
                              </td>
                              <td style={{ padding: "0.2rem" }}>
                                {tutorItem?.tutorInfo?.email}
                              </td>
                              <td style={{ padding: "0.2rem" }}>
                                {tutorItem?.payment_due_date}
                              </td>
                              <td style={{ padding: "0.2rem" }}>
                                {tutorItem?.cycle_completion_date}
                              </td>
                              <td style={{ padding: "0.2rem" }}>
                                {tutorItem?.total_bonus_amount}
                              </td>
                              <td style={{ padding: "0.2rem" }}>
                                {tutorItem?.total_deduction_amount}
                              </td>
                              <td style={{ padding: "0.2rem" }}>
                                {tutorItem?.total_amount}
                              </td>
                              <td style={{ padding: "0.2rem" }}>
                                {tutorItem?.status}
                              </td>
                              <td
                                style={{ display: "flex", padding: "0.2rem" }}
                              >
                                <p
                                  style={{
                                    fontSize: "15px",
                                    color: "blue",
                                    alignItems: "center",
                                    display: "inline-block",
                                    borderRadius: "30%",
                                    marginTop: "14px",
                                    cursor: "pointer",
                                  }}
                                  id={`eyeTooltip-${tutorIndex}`}
                                  onClick={() => getDetail(tutorItem?.id)}
                                >
                                  <i className="fa-solid fa-pen-to-square"></i>
                                </p>

                                <UncontrolledTooltip
                                  placement="top"
                                  target={`eyeTooltip-${tutorIndex}`}
                                >
                                  Edit
                                </UncontrolledTooltip>
                                <p
                                  style={{
                                    margin: "0 8px",
                                    fontSize: "15px",
                                    color: "red",
                                    cursor: "pointer",
                                    display: "inline-block",
                                    borderRadius: "20%",
                                    marginTop: "14px",
                                  }}
                                  onClick={() => {
                                    Delpatroll(tutorItem?.id);
                                  }}
                                  id={`userTooltip-${tutorIndex}`}
                                >
                                  <i className="fas fa-trash"></i>
                                </p>
                                <UncontrolledTooltip
                                  placement="top"
                                  target={`userTooltip-${tutorIndex}`}
                                >
                                  Delete
                                </UncontrolledTooltip>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                  </Col>
                </Row>

             {/*   <CardFooter className="py-4">
                  <TablePagination
                  //totalPages={parseInt(dataList?.meta?.total_page)}
                  //  currentPage={parseInt(dataList?.meta?.current_page)}
                  // pageUrl="/admin/tutors?"
                  />
                </CardFooter>*/}
              </Card>
            </div>
          </Row>
        )}
      </div>
      <Modal isOpen={modal} toggle={toggleModal} size="lg">
        <ModalHeader toggle={toggleModal}>
          <h4> Add Payroll</h4>
        </ModalHeader>

        <ModalBody>
          <Form onSubmit={AddPayroll}>
            <FormGroup>
              <Row>
                <Col md={6}>
                  <Label> Tutor </Label>
                  <Input
                    name="tutor_id"
                    type="select"
                    placeholder="Enter Mobile number"
                    defaultValue={parms?.id}
                    
                   
                    
                  >
                    <option value="">Select</option>
                    {tutor?.map((item, index) => {
                      return (
                        <option key={index} value={item?.user?.id}>
                          {item?.user.first_name} {`(${item?.mobile})`}
                        </option>
                      );
                    })}
                  </Input>
                </Col>
                <Col md={6}>
                  <Label> Class </Label>
                  <Input
                    name="class_id"
                    type="select"
                    placeholder="Enter Mobile number"
                  >
                    <option value="">Select</option>
                    {classlist?.map((item, index) => {
                      return (
                        <option key={index} value={item?.id}>
                          {item?.name}
                        </option>
                      );
                    })}
                  </Input>
                </Col>
              </Row>
            </FormGroup>
            <FormGroup>
              <Row>
                <Col md={6}>
                  <Label> Total Amount </Label>
                  <Input
                    name="total_amount"
                    type="text"
                    placeholder="Enter Total Amount"
                  />
                </Col>
                <Col md={6}>
                  <Label> Bonus Amount </Label>
                  <Input
                    name="total_bonus_amount"
                    type="text"
                    placeholder="Enter Bonus Amount"
                  />
                </Col>
              </Row>
            </FormGroup>
            <FormGroup>
              <Row>
                <Col md={6}>
                  <Label> Bonus note </Label>
                  <Input
                    name="bonus_note"
                    type="textarea"
                    placeholder="Enter Bonus note"
                  />
                </Col>
                <Col md={6}>
                  <Label> Deduction Amount </Label>
                  <Input
                    name="total_deduction_amount"
                    type="text"
                    placeholder="Enter Deduction Amount"
                  />
                </Col>
              </Row>
            </FormGroup>
            <FormGroup>
              <Row>
                <Col md={6}>
                  <Label> Deduction note </Label>
                  <Input
                    name="deduction_note"
                    type="textarea"
                    placeholder="Enter Deduction note"
                  />
                </Col>
                <Col md={6}>
                  <Label> Cycle completion date</Label>
                  <Input name="cycle_completion_date" type="date" />
                </Col>
              </Row>
            </FormGroup>
            <FormGroup>
              <Row>
                <Col md={6}>
                  <Label> Payment due date </Label>
                  <Input name="payment_due_date" type="date" />
                </Col>
                <Col md={6}>
                  <Label> Remark</Label>
                  <Input
                    name="remark"
                    type="text"
                    placeholder="Enter Remarks"
                  />
                </Col>
              </Row>
            </FormGroup>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "20px",
              }}
            >
              <Button color="secondary" onClick={toggleModal}>
                Cancel
              </Button>
              {/* 
                      {addsLoadig ? (
                        <Loader color={"blue"} />
                      ) : ( */}
              <Button
                color="primary"
                type="submit"
                style={{
                  float: "right",
                  marginLeft: "5%",
                  backgroundColor: "#080278",
                  color: "white",
                }}
                // onClick={}
              >
                Add
              </Button>
            </div>
          </Form>
        </ModalBody>
      </Modal>
      <Modal isOpen={modal1} toggle={toggleModal1} size="lg">
        <ModalHeader toggle={toggleModal1}>
          <h4> Edit Payroll</h4>
        </ModalHeader>

        <ModalBody>
        {loading ? (
    <Loader /> // Display loader while fetching data
  ) : (
          <Form onSubmit={EditPayroll}>
            <FormGroup>
              <Row>
                <Col md={6}>
                  <Label> Tutor </Label>
                  <Input
                    name="tutor_id"
                    type="select"
                    placeholder="Enter Mobile number"
                    defaultValue={datadetail?.tutor_id}
                  >
                    {tutor?.map((item, index) => {
                      return (
                        <option key={index} value={item?.user?.id}>
                          {item?.user.first_name} {`(${item?.mobile})`}
                        </option>
                      );
                    })}
                  </Input>
                </Col>
                <Col md={6}>
                  <Label> Class </Label>
                  <Input
                    name="class_id"
                    type="select"
                    placeholder="Enter Mobile number"
                    defaultValue={datadetail?.class_id}
                  >
                    {classlist?.map((item, index) => {
                      return (
                        <option key={index} value={item?.id}>
                          {item?.name}
                        </option>
                      );
                    })}
                  </Input>
                </Col>
              </Row>
            </FormGroup>
            <FormGroup>
              <Row>
                <Col md={6}>
                  <Label> Total Amount </Label>
                  <Input
                    name="total_amount"
                    type="text"
                    placeholder="Enter Total Amount"
                    defaultValue={datadetail?.total_amount}
                  />
                </Col>
                <Col md={6}>
                  <Label> Bonus Amount </Label>
                  <Input
                    name="total_bonus_amount"
                    type="text"
                    placeholder="Enter Bonus Amount"
                    defaultValue={datadetail?.total_bonus_amount}
                  />
                </Col>
              </Row>
            </FormGroup>
            <FormGroup>
              <Row>
                <Col md={6}>
                  <Label> Bonus note </Label>
                  <Input
                    name="bonus_note"
                    type="textarea"
                    placeholder="Enter Bonus note"
                    defaultValue={datadetail?.bonus_note}
                  />
                </Col>
                <Col md={6}>
                  <Label> Deduction Amount </Label>
                  <Input
                    name="total_deduction_amount"
                    type="text"
                    placeholder="Enter Deduction Amount"
                    defaultValue={datadetail?.total_deduction_amount}
                  />
                </Col>
              </Row>
            </FormGroup>
            <FormGroup>
              <Row>
                <Col md={6}>
                  <Label> Deduction note </Label>
                  <Input
                    name="deduction_note"
                    type="textarea"
                    placeholder="Enter Deduction note"
                    defaultValue={datadetail?.deduction_note}
                  />
                </Col>
                <Col md={6}>
                  <Label> Cycle completion date</Label>
                  <Input name="cycle_completion_date" type="date"  defaultValue={formattedCycleDate}/>
                </Col>
              </Row>
            </FormGroup>
            <FormGroup>
              <Row>
                <Col md={6}>
                  <Label> Payment due date </Label>
                  <Input name="payment_due_date" type="date" defaultValue={formattedPaymentDate} />
                </Col>
                <Col md={6}>
                  <Label> Remark</Label>
                  <Input
                    name="remark"
                    type="textarea"
                    placeholder="Enter Remarks"
                    defaultValue={datadetail?.remark }
                  />
                </Col>
              </Row>
            </FormGroup>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "20px",
              }}
            >
              <Button color="secondary" onClick={toggleModal1}>
                Cancel
              </Button>
              {/* 
                      {addsLoadig ? (
                        <Loader color={"blue"} />
                      ) : ( */}
              <Button
                color="primary"
                type="submit"
                style={{
                  float: "right",
                  marginLeft: "5%",
                  backgroundColor: "#080278",
                  color: "white",
                }}
                // onClick={}
              >
                Edit
              </Button>
            </div>
          </Form>)}
        </ModalBody>
      </Modal>
    </>
  );
};

export default Payments;
